import React from "react";
import cx from "classnames";
import { HeaderWithActionsStyled } from "./styled";
import { useHistory } from "react-router-dom";
import { Buttons, Icons } from "components";

const HeaderWithActions = ({
  theme_admin,
  title,
  subTitle,
  svg,
  typeObj,
  typeButton,
  typeBlank,
  handleBackCustom,
  handleClickButton,
  labelButtonTop,
  labelButtonBottom,
  type,
  showButtonDelete,
}) => {
  let history = useHistory();
  const customClass = cx({
    theme_admin: theme_admin,
  });
  const handleClickBack = () => {
    if (handleBackCustom) {
      handleBackCustom();
    } else {
      history.goBack();
    }
  };

  return (
    <HeaderWithActionsStyled>
      <div className={customClass}>
        <div className="box1">
          <div className="btn_link">
            {handleBackCustom && (
              <Buttons.BtnLink
                theme_standard_btn_link
                svg={<Icons.ArrowLeft2 />}
                onClick={handleClickBack}
              />
            )}
          </div>
        </div>
        <div className="box2">
          {svg && <div className="show_svg">{svg}</div>}
          <div className="group_label">
            <div className="top_title">{title}</div>
            <div className="bottom_title">{subTitle}</div>
          </div>
        </div>
        {typeButton && (
          <div className="btn_layer">
            <div className="btn_body">
              <Buttons.BtnNormal
                theme_standard_btn_normal_red
                type={type}
                label={labelButtonTop || "สร้าง"}
                labelBottom={labelButtonBottom || "Create"}
                fontSize="20px"
                fontSizeLabelButtom="16px"
                fontFamilyBottom="noto_sans_thai_medium, noto_sans_regular"
              />
            </div>
          </div>
        )}
        {typeObj && <div className="btn_layer">{typeObj}</div>}
        {showButtonDelete && (
          <div className="btn_layer">
            <div className="btn_body">
              <Buttons.BtnNormal
                theme_standard_btn_normal_red_2
                label="ลบ"
                fontSize="18px"
                onClick={handleClickButton}
                svgFront={<Icons.Delete3 />}
              />
            </div>
          </div>
        )}
        {typeBlank && <div className="blank" />}
      </div>
    </HeaderWithActionsStyled>
  );
};

HeaderWithActions.propTypes = {};

export default HeaderWithActions;
